import { DICTONARY } from 'const/Dictonary';
import adminService from 'services/admin';
import { toast } from 'sonner';
import { AlertaError, AlertaExito, AlertaWarning } from 'utils/Alertas';

export const diccionarioVista = {
  tituloListado: 'Administración de grupos',
  subtituloListado:
    'Crea, edita y elimina los registros de las grupos registrados en la plataforma.',
  tituloTabla: 'Grupos ingresados',
  nombrePrincipal: 'Grupo',
  nombrePrincipalMayuscula: 'GRUPO',
  primerNombrePrincipal: 'grupo',
  primerNombrePrincipalPlural: 'grupos'
};

let activeToastId = null;

export const VerificaNombreGrupo = async (nombreGrupo, options = {}) => {
  const { silent = false } = options;
  /**
   *  se utilizan los siguientes id para las
   *  alertas de validación de nombre de grupo
   *  para evitar que se muestren varias alertas a la vez
   */
  const ALERT_ID_EXISTE = 'nombre-grupo-alert-existe';
  const ALERT_ID_DISPONIBLE = 'nombre-grupo-alert-disponible';
  const ALERT_ID_RESPUESTA_INVALIDA = 'nombre-grupo-alert-respuesta-invalida';
  const ALERT_ID_ERROR = 'nombre-grupo-alert-error';

  try {
    // Cerrar alerta anterior si existe
    if (activeToastId !== null) {
      toast.dismiss(activeToastId);
      activeToastId = null;
    }

    const response = await adminService.validarGrupoRegistrado(
      nombreGrupo,
      DICTONARY.INTERCEPTOR.DESACTIVADO
    );

    if (response.status === 200 && response.data !== undefined) {
      const isRegistered = response.data;

      if (!silent) {
        if (isRegistered) {
          activeToastId = AlertaWarning(
            'El nombre de grupo ingresado no está disponible',
            {
              id: ALERT_ID_EXISTE
            }
          );
        } else {
          activeToastId = AlertaExito(
            'El nombre de grupo ingresado está disponible',
            {
              id: ALERT_ID_DISPONIBLE
            }
          );
        }
      }

      return isRegistered;
    }

    if (!silent) {
      activeToastId = AlertaError('Respuesta inválida del servidor', {
        id: ALERT_ID_RESPUESTA_INVALIDA
      });
    }
    return false;
  } catch (error) {
    console.error('Error en VerificaNombreGrupo:', error);
    if (!silent) {
      activeToastId = AlertaError(error.message || 'Error en la validación', {
        id: ALERT_ID_ERROR
      });
    }
    return false;
  }
};
